import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup } from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { addNewManagement, updateManagement } from '../../../../slices/management/thunk';
import { setRequireCloseModal } from '../../../../slices/management/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { getCompanyList, getManagementList } from '../../../../helpers/establishment/backend_helper';
import OSelect from '../../../../Components/OElements/OSelect';
import OInput from '../../../../Components/OElements/OInput';

const ManagementForm = ({ dataManagement, isEdit, handleToggleModal, isOpen, activeTab, toggleTab }) => {
	const dispatch = useDispatch();

	const [selectedCompany, setSelectedCompany] = useState(null);
	const [selectedManagement, setSelectedManagement] = useState(null);
	const [managementKey, setManagementKey] = useState(Date.now()); // Para forzar la recarga del OSelect

	const handleCompanySelect = (optionSelected) => {
		setSelectedCompany(optionSelected);
	};

	const handleManagementSelect = (optionSelected) => {
		setSelectedManagement(optionSelected);
	};

	const selectorManagement = createSelector(
		state => state.Managements,
		management => ({
			isAdding: management.isAdding,
			isAdded: management.isAdded,
			isUpdating: management.isUpdating,
			isUpdated: management.isUpdated,
			isLoadingList: management.isLoadingList,
			requireCloseModal: management.requireCloseModal,
		})
	);

	const { isAdding, isAdded, isUpdating, isUpdated, isLoadingList, requireCloseModal } = useSelector(selectorManagement);

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: (dataManagement && dataManagement.name) || '',
			company_id: (dataManagement && dataManagement.company_id) || '',
			management_id: '',
			disabled: (dataManagement && dataManagement.disabled) || false,
			// cost_center_name: (dataManagement && dataManagement.cost_center) || '',
			// cost_center: (dataManagement && dataManagement.cost_center) || '',
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Campo requerido'),
			company_id: Yup.string().required('Campo requerido'),
			management_id: Yup.string().nullable(),
			// cost_center_name: Yup.string().nullable(),
			// cost_center: Yup.string().nullable(),
		}),
		onSubmit: values => {
			const managementData = {
				name: values.name,
				company_id: values.company_id,
				management_id: values.management_id,
				disabled: values.disabled,
				// cost_center: values.cost_center,
			};

			if (isEdit) {
				managementData._id = dataManagement._id;
				dispatch(updateManagement(managementData));
			} else {
				dispatch(addNewManagement(managementData));
			}
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	useEffect(() => {
		if (selectedCompany) {
			setManagementKey(Date.now());
		}
	}, [selectedCompany]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={3}>
								<OInput
									name='name'
									label='Nombre del Departamento'
									type='text'
									validation={validation}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>

							{/* <Col lg={3}>
								<OInput
									name='cost_center_name'
									label='Nombre Centro Costo'
									type='text'
									validation={validation}
									lg={3}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>

							<Col lg={3}>
								<OInput
									name='cost_center'
									label='Código Centro Costo'
									type='text'
									validation={validation}
									lg={3}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col> */}
							<Col lg={3}>
								<OSelect
									key={`${dataManagement?.company_id}` || ''}
									label='Empresa'
									id='company_id'
									name='company_id'
									isRequired={true}
									value={validation.values.company_id || ''}
									onSelect={handleCompanySelect}
									requestApi={() => getCompanyList({})}
									disabled={false}
									validation={validation}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									key={`management_id` + dataManagement?.management_id} // Use the key to force re-render
									label='Depende de'
									id='management_id'
									name='management_id'
									value={dataManagement.management_id || ''}
									onSelect={handleManagementSelect}
									requestApi={() => getManagementList({ company_id: selectedCompany?._id })}
									disabled={!selectedCompany}
									validation={validation}
								/>
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 modal-footer-add-btn'>
					<Button className='btn-danger btn-label' onClick={() => handleToggleModal()} ><i className="icon-x label-icon"></i>Cancelar</Button>
					<button type='submit' className='btn btn-label btn-primary' id='add-btn' disabled={isAdding || isUpdating}>{isAdding || isUpdating ? (<i className='label-icon'><Spinner size='sm' /></i>) : <i className="ri-save-3-line label-icon"></i>} {isEdit ? 'Editar' : 'Crear'} departamento</button>
				</div>
			</div>
		</Form>
	);
};

export default ManagementForm;
